<!-- Phone name links to the whitelist; a denied or blocked phone is gone from it, so it is only highlighted -->
@if (removed) {
  <span [innerHTML]="(log?.details?.translationCode | translate : { targetName: log?.details?.targetName | escapeHtml }) | strongWrap : log?.details?.targetName"></span>
} @else {
  <span [innerHTML]="(log?.details?.translationCode | translate : { targetName: log?.details?.targetName | escapeHtml }) | anchorWrap : log?.details?.targetName : log?.details?.targetId : 'MobileWhitelist'"></span>
}
@if (!log?.staffId && log?.staffName === 'Everon Admin') {
  <span [innerHTML]="(' ' + ('BY_USER' | translate : { targetString: 'Everon Admin' })) | strongWrap : 'Everon Admin'"></span>
} @else {
  <span [innerHTML]="(' ' + ('BY_USER' | translate : { targetString: (log?.staffName | identityFormat : log?.staffId) | escapeHtml })) | anchorWrap : (log?.staffName | identityFormat : log?.staffId) : log?.staffId : 'Staff' : '' : true"></span>
}

<p class="mt-1">{{ log?.timestamp | moment : "l LTS" }}</p>

<hr />

<div class="container">
  <span class="item-title">{{ 'PHONE_NAME' | translate }}:</span>
  <div class="item-pair-value" data-testid="mobile-whitelist-name">
    @if (nameChanged) {
      <span class="negative-highlight line-through">{{ changes.oldName || ('NONE' | translate) }}</span>
      <i class="fa-light fa-arrow-right-long fa-lg"></i>
      <span class="positive-highlight">{{ changes.newName || ('NONE' | translate) }}</span>
    } @else {
      <span [ngClass]="{ 'negative-highlight line-through': removed, 'positive-highlight': created }">{{ phoneName || ('NONE' | translate) }}</span>
    }
  </div>

  <span class="item-title">{{ 'GSM_NUMBER' | translate }}:</span>
  <div class="item-pair-value" data-testid="mobile-whitelist-gsm-number">
    @if (numberChanged) {
      <span class="negative-highlight line-through">{{ changes.oldGsmNumber || ('NONE' | translate) }}</span>
      <i class="fa-light fa-arrow-right-long fa-lg"></i>
      <span class="positive-highlight">{{ changes.newGsmNumber || ('NONE' | translate) }}</span>
    } @else {
      <span [ngClass]="{ 'negative-highlight line-through': removed, 'positive-highlight': created }">{{ changes?.gsmNumber || ('NONE' | translate) }}</span>
    }
  </div>
</div>
